// search.tsx
import { Input } from 'antd';
import React from 'react';
interface SearchProps {
    onSearch: (searchText: string) => void;
    className?: string;
}

const Search: React.FC<SearchProps> = ({ onSearch, className }) => {
    return (
        <div className={`flex flex-row border rounded-md overflow-hidden border-slate-300 focus-within:border-primaryColor ${className}`}>
            {/* <button
                type="button"
                className="px-4 py-1 text-white bg-primaryColor duration-300 transition-colors"
            >
                <i className="fas fa-search mr-2"></i>
            </button> */}
            <Input
                id="search"
                name="search"
                placeholder="Search Listing"
                // value={value}
                className="w-full border-none rounded-none shadow-none focus:ring-0 focus:outline-none focus:border-none"
                onChange={(e) => onSearch && onSearch(e.target.value)}
                allowClear
            />
        </div>
    );
};

export default Search;


